import { useMemo } from 'react';

import { deriveStreakState } from '../helpers/streakHelpers';
import useActivePromoQuery from './useActivePromoQuery';
import usePromoItemsQuery from './usePromoItemsQuery';

/**
 * The streak feature's read model: runs the promo + items queries and derives
 * the view state. `isReady` is true once both queries settled — auto-open and
 * visibility decisions must wait for it.
 */
const useStreakState = () => {
  const promoQuery = useActivePromoQuery();
  const promo = promoQuery.data ?? null;
  const itemsQuery = usePromoItemsQuery(promo?.id);

  const streak = useMemo(
    () => deriveStreakState(promo, itemsQuery.data),
    [promo, itemsQuery.data]
  );

  const isReady =
    !promoQuery.isPending && (promo === null || !itemsQuery.isPending);

  return {
    streak,
    promo,
    isReady,
    refetchItems: itemsQuery.refetch,
  };
};

export default useStreakState;
